var exports = module.exports;

exports.getTagAutoSuggestConfig = function getTagAutoSuggestConfig(model, inputId, allowNewTag, includeGlossaryDefinitions, useCache) {
	if (useCache==undefined) useCache = true;
	//get all existing tags
	if (includeGlossaryDefinitions) {
		jQuery.getJSON('/get-all-tags', {includeGlossaryDefinitions:true, useCache: useCache})
    	.done(function(tags) {
    		model.set('_page.existingTags', Object.keys(tags));
    		model.set('_page.tagDefinitions', tags);
    	});
	}
	else {
		jQuery.getJSON('/get-all-tags', {useCache: useCache})
		.done(function(tags) {
			model.set('_page.existingTags', tags);
		});
	}

	var $inputElement = jQuery('#'+inputId);
	var lastResults = [];

	var config = {
		multiple: true
	  , tokenSeparators: [',']

	  , initSelection: function (element, callback) {
			if ($(element).val()) {
				var selection = [];
				var tags = $(element).val().split(',');
				tags.forEach(function(tag) {
					selection.push({id:tag, text:tag});
				});
				callback(selection);
			}
		}

	  , query: function(query) {
			$inputElement.data('newTag', false);

			//don't do query if the user has only entered whitespace
			if (query.term != '') {
				query.term = $.trim(query.term);
				if (!query.term) return false;
			}

			var t = query.term, filtered = {results: []};
		
			$(model.get('_page.existingTags')).each(function () {
				var isObject = this.text !== undefined,
					text = isObject ? this.text : this;
				if (t === "" || query.matcher(t, text)) {
					filtered.results.push(isObject ? this : {id: this, text: this});
				}
			});

			query.callback(filtered);
			lastResults = filtered.results;
		}

	  , tokenizer: function(input, selection, selectCallback, opts) {
			var original = input, // store the original so we can compare and know if we need to tell the search to update its text
				dupe = false, // check for whether a token we extracted represents a duplicate selected choice
				token, // token
				index, // position at which the separator was found
				i, l, // looping variables
				separator; // the matched separator

			while (true) {
				index = -1;

				for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
					separator = opts.tokenSeparators[i];
					index = input.indexOf(separator);
					if (index >= 0) break;
				}

				if (index < 0) break; // did not find any token separator in the input string, bail

				token = input.substring(0, index);
				input = input.substring(index + separator.length);

				if (token.length > 0) {
					token = {id:token, text:token};
					selectCallback(token);
				}
			}

			if (original!==input) return input;
		}
	};

	if (allowNewTag) {
		var additionalConfig = {
			matcher: function(term, text) {
				return term && text && text.toUpperCase().indexOf(term.toUpperCase())>=0;
			}

			//allow new tags to be entered on the fly
		  , createSearchChoice: function(term) {
				term = $.trim(term);
				if (term) {
					$inputElement.data('newTag', term);
					$(lastResults).each(function() {
						if (this.text == term) {
							newTag = false;
							return false;
						}
					});
					return {id:term, text: term};
				}
				else $inputElement.data('newTag', false);

				//var text = isNewTag ? "[NEW TAG] " + term: term;
				//return {id:term, text: text};
			}

			//Give priority to existing tags over new tags
			//Note: This is a customized version of select2 with a new option I added called 'autoSelectClosestMatch',
			//taking inspiration from this issue: https://github.com/ivaynberg/select2/issues/794
			//
			//TODO create a pull request for this on github
			//
		  , autoSelectClosestMatch: true
		};

		for (var key in additionalConfig) {
			config[key] = additionalConfig[key];
		}
	}

	return config;
};

//TODO
//Why is this being called 4 times instead of 2 times on the homepage?
//
exports.initComposersOrLyricistsField =
//Note: model parameter is only required for searches (i.e. when passing composer or lyricist IDs as the first argument), otherwise
//the root model gets looked up from the showOrSong model (model = showOrSong.root)
function initComposersOrLyricistsField(showOrSong_or_composerOrLyricistIds, composersOrLyricists, allowNew, lastBeforeFirst, model,
	useCache, additionalOptions)
{
	if (useCache==undefined) useCache = true;
	if (additionalOptions == undefined) additionalOptions = {};

	//selector for <input> element
	var elemSelector = additionalOptions.elemSelector || '#' + composersOrLyricists;
	
	//the variable is named composerIds just for convenience (since it's shorter than composerOrLyricistIds);
	//for lyricsts, it would contain lyricst IDs
	var composerIds;

	if (!showOrSong_or_composerOrLyricistIds) {
		composerIds = [];
	}
	//If the first argument is a string of IDs then we know this is for the song search form
	else if (typeof showOrSong_or_composerOrLyricistIds == 'string') {
		composerIds = showOrSong_or_composerOrLyricistIds.split(';');
	}
	else if (Array.isArray(showOrSong_or_composerOrLyricistIds)) {
		composerIds = showOrSong_or_composerOrLyricistIds;
	}
	else {
		var showOrSong = showOrSong_or_composerOrLyricistIds,
			composers = showOrSong.get(composersOrLyricists) || {};

		composerIds = Object.keys(composers);
		if (!model) model = showOrSong.root;
	}

	//TODO
	//If a person is both a composer and a lyricist, they ought to be represented as the same person, with the
	//same ID, in the database. But we do want the auto-suggest to suggest only composers, or only lyricists,
	//as it does now thanks to having them in separate collections.

	//We retrieve composers/lyricists from the server so that we can cache the list of composers/lyricists
	$.getJSON('/get-all-'+composersOrLyricists, {useCache: useCache}, function(allComposers) {
		//TODO don't allow typing in the name of an item that's already in the list and adding the same item more than once
		//allow new items to be entered on the fly
		var createSearchChoice = function(term) {
			//TODO make sure String.prototype.trim shim is loaded for older browsers
			term = term.trim();
			if (term) return {id:term, text: term};
		};

		//in case any composer/lyricist was deleted
		var validComposerIds = [];
		composerIds.forEach(function(id) {
			if (id in allComposers) validComposerIds.push(id);
		});
		
		var multipleSelect = (additionalOptions.multipleSelect == undefined ? true: additionalOptions.multipleSelect);
		if (multipleSelect) {
			$(elemSelector).val( validComposerIds.join(';') );
		}
		else if (validComposerIds[0]) {
			$(elemSelector).val(validComposerIds[0]);
		}

		var newComposer = false;
		
		var config = {
			multiple: multipleSelect
		  , separator: ';'

		  , initSelection: function (element, callback) {
				var selection = [];
				var val = $(element).val();
				if (!val) return;
				var composerIds = val.split(';');
				composerIds.forEach(function(id) {
	                composer = allComposers[id];
					if (!composer) {
						throw Error('Missing composer or lyricist ID ' + id);
					}
					
	                //prepare the text that will be displayed as the label for this composer/lyricist
	                var text;
	                if (lastBeforeFirst) {
	                    text = composer.lastName + ', ' + composer.firstName;
	                }
	                else text = composer.firstName + ' ' + composer.lastName;

	                selection.push({id:id, text:text});
	            });
				callback(selection);
			}

			//As per Steven's request, this only matches the beginning of the string now, not the middle,
			//but we should improve it to be able to match from the beginning of the first name too and not only the last
		  , matcher: function(term, text) {
		        return term && text && text.toUpperCase().indexOf(term.toUpperCase()) == 0;
			}

		  , query: function(query) {
				newComposer = false;

				//don't do query if the user has only entered whitespace
				if (query.term != '') {
					query.term = $.trim(query.term);
					if (!query.term) return false;
				}

				var t = query.term, filtered = {results: []};
				for (var composerId in allComposers) {
					var composer = allComposers[composerId];

					//is it a match?
	                var text;
	                if (lastBeforeFirst) {
	                    text = composer.lastName + ', ' + composer.firstName;
	                }
	                else text = composer.firstName + ' ' + composer.lastName;

					if (t === "" || query.matcher(t, text)) {
						var item = {id: composer.id, text: text};
						filtered.results.push(item);
					}
				}

				query.callback(filtered);
				lastResults = filtered.results;
			}
		}

		if (allowNew) {
			var additionalConfig = {
//				matcher: function(term, text) {
//					return term && text && text.toUpperCase().indexOf(term.toUpperCase())>=0;
//				}

				//allow new composers to be entered on the fly
				createSearchChoice: function(term) {
					term = $.trim(term);
					if (term) {
						newComposer = term;
						$(lastResults).each(function() {
							if (this.text == term) {
								newComposer = false;
								return false;
							}
						});
						return {id:term, text: term};
					}
					else newTag = false;
				}

				//Give priority to existing tags over new tags
				//Note: This is a customized version of select2 with a new option I added called 'autoSelectClosestMatch',
				//taking inspiration from this issue: https://github.com/ivaynberg/select2/issues/794
			  , autoSelectClosestMatch: true
			};

			for (var key in additionalConfig) {
				config[key] = additionalConfig[key];
			}
		}

		$(elemSelector).select2(config);

		if (allowNew) {
			$(elemSelector).on("select2-highlight", function(e) {
				if (newComposer) {
					var $match = $('.select2-result:nth-child(2) .select2-match');
					if ($match.length==0) $match = $('.select2-result:first-child .select2-match');
					if ($match.length==0) $match = $('.select2-result:nth-child(2) .select2-result-label');

					$match.html('[NEW] ' + newComposer);
				}
			});
		}
	});
}